import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBullhornQuiet = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.336 22L19.855 28.252C20.0524 28.7437 20.0466 29.2937 19.8389 29.7812C19.6311 30.2687 19.2384 30.6538 18.747 30.852V30.852C18.2553 31.0494 17.7053 31.0436 17.2178 30.8359C16.7303 30.6281 16.3452 30.2354 16.147 29.744L13 22",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 14H13C11.9391 14 10.9217 14.4214 10.1716 15.1716C9.42143 15.9217 9 16.9391 9 18C9 19.0609 9.42143 20.0783 10.1716 20.8284C10.9217 21.5786 11.9391 22 13 22H19L27 26V10L19 14Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29 15V21C29.7956 21 30.5587 20.6839 31.1213 20.1213C31.6839 19.5587 32 18.7956 32 18C32 17.2044 31.6839 16.4413 31.1213 15.8787C30.5587 15.3161 29.7956 15 29 15Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgBullhornQuiet);
export default ForwardRef;
